module.exports = __webpack_public_path__ + "static/008-8b9964868b7d48c7d09da476c0c98048.jpg";